import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col md:flex-row flex-wrap lg:flex-nowrap text-12px xxl:text-14px items-start lg:items-center gap-2 md:gap-0 w-full md:w-auto" }
const _hoisted_2 = { class: "font-semibold text-20px mb-2 mr-4 lg:mb-0 whitespace-nowrap text-black-lp-200 capitalize w-full lg:w-auto" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 5 }
const _hoisted_9 = { key: 7 }
const _hoisted_10 = { key: 8 }
const _hoisted_11 = { key: 9 }
const _hoisted_12 = { class: "flex flex-row lg:space-x-4 w-full lg:w-auto justify-end" }
const _hoisted_13 = { class: "ml-1 relative" }
const _hoisted_14 = { class: "inline-flex" }
const _hoisted_15 = {
  key: 0,
  class: "flex flex-col py-6 transition duration-1000 ease-linear"
}
const _hoisted_16 = {
  key: 1,
  class: "flex flex-row justify-end border-t border-gray-lp-400"
}
const _hoisted_17 = {
  key: 0,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 ml-2"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.9646 9.07133L8.5946 5.75533C8.26527 5.43133 7.7326 5.43133 7.40326 5.75533L4.0346 9.07133C3.70526 9.39466 3.70526 9.91933 4.0346 10.2433C4.3626 10.5673 4.8966 10.5673 5.2246 10.2433L7.99993 7.514L10.7733 10.2433C11.1026 10.5673 11.6353 10.5673 11.9646 10.2433C12.1286 10.082 12.2106 9.86933 12.2106 9.65733C12.2106 9.44533 12.1286 9.23266 11.9646 9.07133Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_19 = {
  key: 1,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 ml-2"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.9639 5.75466C11.6359 5.43066 11.1019 5.43066 10.7739 5.75466L7.99924 8.48399L5.22591 5.75466C4.89657 5.43066 4.36391 5.43066 4.03457 5.75466C3.87057 5.91666 3.78857 6.12866 3.78857 6.34066C3.78857 6.55266 3.87057 6.76532 4.03457 6.92666L7.40457 10.2427C7.73391 10.5667 8.26657 10.5667 8.59591 10.2427L11.9646 6.92666C12.2932 6.60332 12.2932 6.07866 11.9639 5.75466Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_Search = _resolveComponent("Search")!
  const _component_advanced_filter = _resolveComponent("advanced-filter")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_button_fill = _resolveComponent("button-fill")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      class: `py-6 flex flex-col lg:flex-row justify-between lg:items-center ${_ctx.isBorderBottom ? 'border-b' : ''} border-gray-lp-900 gap-2 lg:gap-0`
    }, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, _toDisplayString(_ctx.currentRoutes), 1),
          (_ctx.isSelectSearch)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode(_component_SelectSearch, {
                  placeholder: _ctx.placeholderOrigin,
                  value: _ctx.searchValueOrigin,
                  dataSearch: _ctx.selectSearchDataOrigin,
                  onSearch: _ctx.onSelectSearchOrigin,
                  onOpenSearch: _ctx.onOpenSelectSearchOrigin,
                  onCloseSearch: _ctx.onCloseSelectSearchOrigin,
                  onChooseSearch: _ctx.onChooseSelectSearchOrigin,
                  isOpenSearch: _ctx.statusSelectSearchOrigin,
                  notFound: _ctx.selectSearchOriginNotFound,
                  noSpaceLeft: false,
                  noSpaceRight: true,
                  class: "w-56"
                }, null, 8, ["placeholder", "value", "dataSearch", "onSearch", "onOpenSearch", "onCloseSearch", "onChooseSearch", "isOpenSearch", "notFound"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isSelectSearch)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode(_component_SelectSearch, {
                  placeholder: _ctx.placeholderDestination,
                  value: _ctx.searchValueDestination,
                  dataSearch: _ctx.selectSearchDataDestination,
                  onSearch: _ctx.onSelectSearchDestination,
                  onOpenSearch: _ctx.onOpenSelectSearchDestination,
                  onCloseSearch: _ctx.onCloseSelectSearchDestination,
                  onChooseSearch: _ctx.onChooseSelectSearchDestination,
                  isOpenSearch: _ctx.statusSelectSearchDestination,
                  notFound: _ctx.selectSearchDestinationNotFound,
                  noSpaceLeft: true,
                  noSpaceRight: false,
                  class: "w-56"
                }, null, 8, ["placeholder", "value", "dataSearch", "onSearch", "onOpenSearch", "onCloseSearch", "onChooseSearch", "isOpenSearch", "notFound"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isSearchable)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode(_component_Search, {
                  onInput: _ctx.searchAction,
                  onClear: _ctx.clearSearch,
                  value: _ctx.searchValue,
                  placeholder: _ctx.placeholder,
                  class: _ctx.isSelectReference ? `w-48` : 'w-56'
                }, null, 8, ["onInput", "onClear", "value", "placeholder", "class"])
              ]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "afterSearch"),
          (_ctx.isAdvancedFilter)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode(_component_advanced_filter, {
                  modelValue: _ctx.advancedFilterData,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.advancedFilterData = $event)),
                  isPeriode: _ctx.isFilterPeriode,
                  isOriginDestination: _ctx.isFilterOriginDestination,
                  isClientPartner: _ctx.isFilterClientPartner,
                  isStatus: _ctx.isFilterStatus,
                  isProduct: _ctx.isFilterProduct,
                  isCOD: _ctx.isFilterCOD,
                  isAsuransi: _ctx.isFilterAsuransi,
                  isDisabled: _ctx.isFilterDisabled,
                  addSumFilter: _ctx.addSumFilter,
                  onChange: _ctx.onChangeAdvancedFilter,
                  onOpened: _ctx.onOpenedAdvancedFilter,
                  onReset: _ctx.onResetAdvancedFilter
                }, null, 8, ["modelValue", "isPeriode", "isOriginDestination", "isClientPartner", "isStatus", "isProduct", "isCOD", "isAsuransi", "isDisabled", "addSumFilter", "onChange", "onOpened", "onReset"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isSelectType)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode(_component_Select, {
                  dataSelect: _ctx.typeData,
                  onOpenSelect: _ctx.onOpenTypeSelect,
                  onCloseSelect: _ctx.onCloseTypeSelect,
                  onChooseSelect: _ctx.onSelectType,
                  value: _ctx.valueType,
                  isOpenMenu: _ctx.typeSelect,
                  class: _ctx.isSelectReference ? `w-40 whitespace-no-wrap` : 'w-56 lg:w-50',
                  longTrim: 17,
                  isDisabled: _ctx.isSelectTypeDisable
                }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu", "class", "isDisabled"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isSelectReference)
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _createVNode(_component_Select, {
                  dataSelect: _ctx.referenceData,
                  onOpenSelect: _ctx.onOpenReferenceSelect,
                  onCloseSelect: _ctx.onCloseReferenceSelect,
                  onChooseSelect: _ctx.onSelectReference,
                  value: _ctx.valueReference,
                  isOpenMenu: _ctx.referenceSelect,
                  isDisabled: _ctx.isDisable,
                  class: _ctx.isSelectReference ? `w-40 whitespace-no-wrap` : 'w-50'
                }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu", "isDisabled", "class"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isSelectKurs)
            ? (_openBlock(), _createBlock(_Fragment, { key: 6 }, [
                _createVNode(_component_Select, {
                  dataSelect: _ctx.kursAwalData,
                  onOpenSelect: _ctx.onOpenKursAwalSelect,
                  onCloseSelect: _ctx.onCloseKursAwalSelect,
                  onChooseSelect: _ctx.onSelectKursAwal,
                  value: _ctx.valueKursAwal,
                  isOpenMenu: _ctx.kursAwalSelect,
                  isDisabled: _ctx.isDisable,
                  class: 'w-48'
                }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu", "isDisabled"]),
                _createVNode(_component_Select, {
                  dataSelect: _ctx.kursTukarData,
                  onOpenSelect: _ctx.onOpenKursTukarSelect,
                  onCloseSelect: _ctx.onCloseKursTukarSelect,
                  onChooseSelect: _ctx.onSelectKursTukar,
                  value: _ctx.valueKursTukar,
                  isOpenMenu: _ctx.kursTukarSelect,
                  isDisabled: _ctx.isDisable,
                  class: 'w-48'
                }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu", "isDisabled"])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.isSelectStatus)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _createVNode(_component_Select, {
                  dataSelect: _ctx.statusData,
                  onOpenSelect: _ctx.onOpenStatusSelect,
                  onCloseSelect: _ctx.onCloseStatusSelect,
                  onChooseSelect: _ctx.onSelectStatus,
                  value: _ctx.valueStatus,
                  isOpenMenu: _ctx.statusSelect,
                  class: _ctx.isSelectReference ? `w-40 whitespace-no-wrap` : 'w-56 lg:w-48'
                }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu", "class"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isSelectSearchSingle)
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                _createVNode(_component_SelectSearch, {
                  placeholder: _ctx.placeholderSelectSearchSingle,
                  value: _ctx.searchValueSelectSearchSingle,
                  dataSearch: _ctx.selectSearchSingleData,
                  onSearch: _ctx.onSelectSearchSingle,
                  onOpenSearch: _ctx.onOpenSelectSearchSingle,
                  onCloseSearch: _ctx.onCloseSelectSearchSingle,
                  onChooseSearch: _ctx.onChooseSelectSearchSingle,
                  isOpenSearch: _ctx.statusSelectSearchSingle,
                  notFound: _ctx.selectSelectSearchSingle,
                  noSpaceLeft: false,
                  noSpaceRight: false,
                  class: 'w-56'
                }, null, 8, ["placeholder", "value", "dataSearch", "onSearch", "onOpenSearch", "onCloseSearch", "onChooseSearch", "isOpenSearch", "notFound"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isSelectRenewal)
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _createVNode(_component_Select, {
                  dataSelect: _ctx.statusDataRenewal,
                  onOpenSelect: _ctx.onOpenStatusSelectRenewal,
                  onCloseSelect: _ctx.onCloseStatusSelectRenewal,
                  onChooseSelect: _ctx.onSelectStatusRenewal,
                  value: _ctx.valueStatusRenewal,
                  isOpenMenu: _ctx.statusSelectRenewal,
                  class: _ctx.isSelectReference ? `w-40 whitespace-no-wrap` : 'w-48'
                }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu", "class"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            (_ctx.isOpenTooltip)
              ? (_openBlock(), _createBlock(_component_Tooltip, {
                  key: 0,
                  title: "",
                  message: "Download STT",
                  footer: "",
                  isArrowBottom: false,
                  isArrowRight: "",
                  style: {"width":"150px","margin-top":"-0.5em","margin-left":"-11em"}
                }))
              : _createCommentVNode("", true),
            (_ctx.isButtonDownload)
              ? (_openBlock(), _createBlock(_component_lp_button, {
                  key: 1,
                  onClick: _ctx.buttonDownloadAction,
                  "text-color": "red-lp-300",
                  outline: "",
                  small: "",
                  icon: "document-download-outline",
                  onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onOpenTooltip(true))),
                  onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onOpenTooltip(false)))
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_14, [
            (_ctx.isButtonAction)
              ? (_openBlock(), _createBlock(_component_button_fill, {
                  key: 0,
                  title: _ctx.buttonText,
                  isLoading: _ctx.isLoading,
                  onClick: _ctx.buttonAction,
                  class: 'px-2 md:px-8 whitespace-nowrap bg-red-lp-300'
                }, null, 8, ["title", "isLoading", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 2),
    (_ctx.isFilterShow)
      ? (_openBlock(), _createBlock("div", _hoisted_15, [
          _renderSlot(_ctx.$slots, "filter")
        ]))
      : _createCommentVNode("", true),
    (_ctx.ableToFilter)
      ? (_openBlock(), _createBlock("div", _hoisted_16, [
          _createVNode("button", {
            class: "focus:outline-none flex flex-row items-center text-black-lp-200 text-12px px-4 py-2 mr-6 border-l border-b border-r border-gray-lp-400 rounded-b shadow",
            onClick: _cache[4] || (_cache[4] = () => _ctx.setFilterShow(!_ctx.isFilterShow))
          }, [
            _createVNode("div", null, _toDisplayString(_ctx.isFilterShow ? _ctx.$t("hideFilter") : _ctx.$t("showFilter")) + " Filter", 1),
            (_ctx.isFilterShow)
              ? (_openBlock(), _createBlock("svg", _hoisted_17, [
                  _hoisted_18
                ]))
              : (_openBlock(), _createBlock("svg", _hoisted_19, [
                  _hoisted_20
                ]))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}